// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style__buttons__0IyEY","name":"style__name__c0F5h","area":"style__area__s66gQ"};